import { render, staticRenderFns } from "./InfoSelect.vue?vue&type=template&id=6358deb2&scoped=true"
import script from "./InfoSelect.vue?vue&type=script&lang=js"
export * from "./InfoSelect.vue?vue&type=script&lang=js"
import style0 from "./InfoSelect.vue?vue&type=style&index=0&id=6358deb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6358deb2",
  null
  
)

export default component.exports